import { useEffect, useRef } from 'react';
import { usePathname } from 'expo-router';
import { PostHogProvider } from 'posthog-react-native';

import { isEmbedded } from '../../config/runtimeConfig';

import { posthog } from './posthog';
import { initDatadog } from './datadog';
import { analytics } from './analytics';

// Under embed the host owns the PostHog client + provider upstream and the
// screen-change tracker; nesting our own would double-fire pageviews.
export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const embedded = isEmbedded();

  useEffect(() => {
    if (embedded) return;
    initDatadog();
  }, [embedded]);

  if (embedded) return <>{children}</>;

  // Falsy client → PostHogProvider would construct `new PostHog('')` and log an error.
  if (!posthog) {
    return <AutoCaptureScreen>{children}</AutoCaptureScreen>;
  }

  return (
    <PostHogProvider client={posthog} autocapture={false}>
      <AutoCaptureScreen>{children}</AutoCaptureScreen>
    </PostHogProvider>
  );
}

function AutoCaptureScreen({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const lastPathname = useRef<string | null>(null);

  useEffect(() => {
    if (pathname === lastPathname.current) return;
    lastPathname.current = pathname;
    analytics.trackScreen(pathname);
  }, [pathname]);

  return <>{children}</>;
}
